<script>
    export let company_data;
    
    let src_passo_1 = 'img/passo-1-amarelo.jpg';
    let src_passo_2 = 'img/passo-2-amarelo.jpg';
    let src_passo_3 = 'img/passo-3-amarelo.jpg';

    let phones = company_data.phones;
    let whatsapp = company_data.whatsapp;
</script>

<style>
    .monte-seu-pedido {
        font-family: "Poppins", sans-serif;
        padding-top: 100px;
    }

    .monte-seu-pedido h1 {
        font-size: 36px;
        font-weight: 600;
    }

    .monte-seu-pedido p {
        color: #777;
        font-size: 14px;
    }

    .single-dish {
        padding-top: 70px;
        padding-bottom: 70px;
        text-align: center;
    }

    .single-dish img {
        -webkit-transition: all 0.3s ease 0s;
        -moz-transition: all 0.3s ease 0s;
        -o-transition: all 0.3s ease 0s;
        transition: all 0.3s ease 0s;
    }

    .single-dish:hover img {
        transform: rotate(5deg) scale(1.2);
    }

    .single-dish:hover h4 {
        color: #f42f2c;
    }

    .single-dish b a{
        color: #f42f2c;
    }

    .passo {
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>

<main>
    <section id="monte-seu-pedido" class="monte-seu-pedido">
        <div class="container">
            <div class="justify-content-center">
                <div class="title text-center">
                    <h1>Monte seu prato como quiser!</h1>
                    <p>
                        É muito simples fazer seu pedido, basta seguir os três
                        passos abaixo.
                    </p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row d-flex justify-content-center">
                <div class="single-dish col-lg-4">
                    <img src="{src_passo_1}" alt="" />
                    <h4 class="passo text-uppercase">PASSO 1</h4>
                    <p>
                        Escolha o tamanho do pedido:
                        <br />
                        <b>Família</b>
                        (para 4 pessoas) ou
                        <br />
                        <b>Casal</b>
                        (para 2 pessoas).
                    </p>
                </div>
                <div class="single-dish col-lg-4">
                    <img src="{src_passo_2}" alt="" />
                    <h4 class="passo text-uppercase">PASSO 2</h4>
                    <p>Escolha um Prato Principal e três Acompanhamentos</p>
                </div>
                <div class="single-dish col-lg-4">
                    <img src="{src_passo_3}" alt="" />
                    <h4 class="passo text-uppercase">PASSO 3</h4>
                    <p>
                        Ligue e faça o seu pedido!<br />
                        <b>
                            {#each phones as phone, i}
                                {#if i > 0}
                                &nbsp; |&nbsp;
                                {/if}
                                <a href="{phone.url}">{phone.description}</a>
                            {/each}
                        </b>
                        <!-- <b><a href="{telefone_url}">{telefone}</a> | <a href="{telefone_url_2}">{telefone_2}</a></b> -->
                        <br />
                        Ou também por Whatsapp<br />
                        <b><a href="{whatsapp.url}">{whatsapp.description}</a></b>
                    </p>
                </div>
            </div>
        </div>
    </section>
</main>
